import type { Countdown } from "./countdown.types";

type CloudCountdown = {
  $id: string;
  localId?: number;
  title?: string;
  category?: string;
  eventAt?: number;
  journeyEnabled?: boolean;
  note?: string;
  createdAt?: number;
  updatedAt?: number;
};

export function fromCloudCountdown(
  row: CloudCountdown,
): Countdown {
  return {
    id: row.$id,
    cloudId: row.$id,
    title: row.title || "Countdown",
    category: row.category || "Personal",
    eventAt: new Date(
      Number(row.eventAt || 0),
    ).toISOString(),
    journeyEnabled: Boolean(row.journeyEnabled),
    notes: row.note || "",
    createdAt: Number(row.createdAt || Date.now()),
    updatedAt: Number(row.updatedAt || Date.now()),
  };
}

export function toCloudCountdown(
  countdown: Countdown,
): Record<string, unknown> {
  return {
    localId: countdown.createdAt,
    title: countdown.title,
    category: countdown.category,
    eventAt: new Date(countdown.eventAt).getTime(),
    journeyEnabled: countdown.journeyEnabled,
    note: countdown.notes || "",
    deleted: false,
    createdAt: countdown.createdAt,
    updatedAt: countdown.updatedAt,
  };
}